import React from "react";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../db/firebase";
import { AnimatedModal } from "./AnimatedModal";
import { HiOutlineXMark, HiOutlineUser } from "react-icons/hi2";

interface User {
  id: string;
  firstName: string;
  lastName: string;
}

interface UserInfoModalProps {
  user: User;
  isOpen: boolean;
  onClose: () => void;
  boardId: string;
  onRemoveUser: (userId: string) => void;
}

const UserInfoModal: React.FC<UserInfoModalProps> = ({
  user,
  isOpen,
  onClose,
  boardId,
  onRemoveUser,
}) => {
  const handleRemoveUser = async () => {
    try {
      await deleteDoc(doc(db, "memberships", `${boardId}_${user.id}`));
      onRemoveUser(user.id);
      onClose();
    } catch (error) {
      console.error("Error removing user: ", error);
    }
  };

  if (!isOpen) return null;

  return (
    <AnimatedModal isOpen onClose={onClose} backdropClassName="bg-black/60 backdrop-blur-sm">
      <div className="relative w-full max-w-md rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-700 bg-gradient-to-r from-gray-50 to-white dark:from-gray-800 dark:to-gray-800/80">
          <div className="flex items-center gap-2.5">
            <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#5932EA]/10 dark:bg-[#5932EA]/20 text-[#5932EA]">
              <HiOutlineUser className="w-5 h-5" strokeWidth={2} />
            </div>
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              User Info
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-xl text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <HiOutlineXMark className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <div className="space-y-2">
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                First Name
              </p>
              <p className="text-gray-800 dark:text-gray-200">{user.firstName}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                Last Name
              </p>
              <p className="text-gray-800 dark:text-gray-200">{user.lastName}</p>
            </div>
          </div>
          <div className="flex gap-3 pt-2">
            <button
              onClick={handleRemoveUser}
              className="flex-1 py-2.5 rounded-xl font-medium bg-red-500 text-white hover:bg-red-600 transition-colors"
            >
              Remove User
            </button>
            <button
              onClick={onClose}
              className="flex-1 py-2.5 rounded-xl font-medium border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default UserInfoModal;
